export const getUrlParam = (name: string) => {
    const urlParams = new URLSearchParams(window.location.search);

    return urlParams.get(name);
};
